export enum TelemetryModel {
	Device = "Device",
	User = "User",
	Shipment = "Shipment",
	Route = "Route",
	Plate = "Plate",
	None = "None"
}
